import DivisionService from 'src/modules/division/divisionService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'DIVISION_VIEW';

const divisionViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: divisionViewActions.FIND_STARTED,
      });

      const record = await DivisionService.find(id);

      dispatch({
        type: divisionViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: divisionViewActions.FIND_ERROR,
      });

      getHistory().push('/division');
    }
  },
};

export default divisionViewActions;
